import './PDP/category-carousel';

// Send event to Google Analytics 4 when user interacts with the
// thumbnail images on the product page.

document.addEventListener('DOMContentLoaded', () => {
  const prodGalleryThumbsWrapper = document.querySelector('[data-product-images] [data-product-thumbs] .product__thumbs--scroller');
  if (!prodGalleryThumbsWrapper) return;

  prodGalleryThumbsWrapper.addEventListener('click', (e) => {
    if (e.target && e.target.closest('.product__thumb-item')) {
      const clickedThumb = e.target.closest('.product__thumb-item');
      const index = clickedThumb?.getAttribute('data-index');
      if (clickedThumb && index) {
        const imageNumber = parseInt(index, 10) + 1;
        // Send event Google Analytics 4
        window.gtag('event', 'pdp_carousel_navigation_with_thumbnails', {
          carousel_id: 'product_images_gallery_with_thumbs',
          image_number: imageNumber,
          page_location: window.location.href
        });
      }
    } else {
      const productThumbsItems = prodGalleryThumbsWrapper.querySelectorAll('.product__thumb-item');
      productThumbsItems.forEach(item => {
        let isActive = item.querySelector('.product__thumb.is-active');
        if (isActive) {
          const index = item.getAttribute('data-index');
          const imageNumber = parseInt(index, 10) + 1;
          // Send event Google Analytics 4
          window.gtag('event', 'pdp_carousel_navigation_with_thumbnails', {
            carousel_id: 'product_images_gallery_with_thumbs',
            image_number: imageNumber,
            page_location: window.location.href
          });
        }
      });
    }
  });
});